export default "__VITE_ASSET__757db832__"